import type { AxiosRequestConfig } from "axios"
import { useMemo } from "react"

// this is the key for the cached device data
export function useDeviceSWRKey(): AxiosRequestConfig | undefined {
  const swrKey = useMemo(
    () => {
      const url = "/api/v3/devices/me"

      return {
        url,
      }
    },
    [],
  )

  return swrKey
}
